export {default} from './PersonalPerformanceSection.connect';
